import { createContext, useContext } from 'react'

const GlobalContext = createContext({})

export const useGlobalContext = () => {
  const context = useContext(GlobalContext)
  if (!context) {
    throw new Error(
      'useGlobalContext must be used within a GlobalContext.Provider'
    )
  }
  return context
}

export default GlobalContext
